import { render } from "./IconLocalShipping.vue?vue&type=template&id=167d0333"
import script from "./IconLocalShipping.vue?vue&type=script&lang=js"
export * from "./IconLocalShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__